<template>
  <div class="relation-list" v-show="items && items.length > 0">
    <div
      class="relation-list__item"
      :class="{ 'is-selected': index === selectedIndex }"
      v-for="(item, index) in items"
      :key="index"
      @click="selectItem(index)"
    >
      <div class="date">
        <span>{{ item.created_at }}</span>
      </div>
      <div class="content" v-html="handleContent(item.content)"></div>
    </div>
  </div>
</template>

<script>
import app from '@/main.js'
import MemoUtil from '@/utils/MemoUtil'
import logPageView from '../../../utils/logPageView'

export default {
  props: {
    items: {
      default: () => [],
      type: Array,
      required: true,
    },
    command: {
      type: Function,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedIndex: 0,
    }
  },
  watch: {
    items() {
      this.selectedIndex = 0
    },
  },

  methods: {
    onKeyDown({ event }) {
      const relationListDom = document.querySelector('.relation-list')
      if (event.key === 'ArrowUp') {
        if (this.selectedIndex + 1 > 3) {
          relationListDom.scrollTop -= 102
        }
        this.upHandler()
        return true
      }
      if (event.key === 'ArrowDown') {
        if (this.selectedIndex + 1 > 3 && this.selectedIndex <= this.items.length) {
          relationListDom.scrollTop += 100
        }
        this.downHandler()
        return true
      }
      if (event.key === 'Enter') {
        event.preventDefault()
        event.stopPropagation()
        this.enterHandler()
        return true
      }
      return false
    },
    upHandler() {
      this.selectedIndex = (this.selectedIndex + this.items?.length - 1) % this.items?.length
    },
    downHandler() {
      this.selectedIndex = (this.selectedIndex + 1) % this.items?.length
    },
    enterHandler() {
      this.selectItem(this.selectedIndex)
    },
    selectItem(index) {
      const item = this.items[index]
      if (!app.$store.getters.is_pro) {
        this.command({ id: '' })

        // return app.$message.error(app.$t('components.Memo.relation') + '' + app.$t('pages.RecordStat.proTip'))
        this.$confirm(app.$t('components.only_pro.tips.content'), app.$t('components.Memo.relation'), {
          confirmButtonText: app.$t('components.only_pro.tips.confirm'),
          customClass: 'confirm',
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
        })
          .then(() => {
            app.$store.commit('setSelectedSource', 'membership')
            const url = 'mine?source=membership&from=thread'
            window.history.pushState(null, null, url)
            logPageView('membership', 'thread')
          })
          .catch(() => {})
        return
      }
      if (item) {
        this.command({ id: MemoUtil.getMemoUrl(item.slug) })
      }
    },
    handleContent(str) {
      const keywords = this.query.split(' ')
      str = str.replace(/<p>/g, ' ').replace(/<\/p>/g, ' ')
      let res = str.replace(/<[^>]+>/g, '')

      keywords.forEach((keyword) => {
        if (keyword === '') {
          return
        }
        res = res.replace(new RegExp(keyword, 'ig'), `<span class="highlight">${keyword}</span>`)
      })

      return res
    },
  },
}
</script>
<style scoped>
.relation-list {
  max-height: 450px;
  overflow-y: auto;
  border-radius: 5px;
  background: var(--glassBg);
  border: 1px solid #e2e2e2;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
  max-width: 380px;
  overflow-x: hidden;
  backdrop-filter: blur(12px) saturate(190%) contrast(50%) brightness(130%);
}

/* 适配 tray */
@media (max-width: 500px) {
  .relation-list {
    max-width: 90vw;
  }
}

@media (max-height: 500px) {
  .relation-list {
    max-height: 60vh !important;
  }
}

.relation-list::-webkit-scrollbar {
  width: 5px !important;
  height: 10px !important;
  border-radius: 10px;
}
.relation-list::-webkit-scrollbar-thumb {
  background: var(--scrollbarThumb);
}
.relation-list__no-results {
  padding: 0.2rem 0.5rem;
}
.relation-list__item {
  padding: 11px 16px;
  cursor: pointer;
  /* max-height: 102px; */
  /* overflow: hidden; */
}

.relation-list__item .date {
  color: #8f9193;
  font-size: 12px;
  margin-bottom: 11px;
}

.relation-list__item .content {
  height: 48px;
  line-height: 24px;
  color: var(--memoContentColor);
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.relation-list__item .content .highlight {
  background: #fffa76;
  color: #000;
  font-weight: bold;
}

.relation-list__item:last-child {
  margin-bottom: 0;
}
.relation-list__item.is-selected,
.relation-list__item:hover {
  background: var(--tagHoverBg);
}
.relation-list__item.is-empty {
  opacity: 0.5;
}
body.dark_mode .relation-list {
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.9) !important;
  border: 1px solid rgba(0, 0, 0, 0.5);
  /* background: #2e2e2e; */
  backdrop-filter: blur(10px) saturate(190%) contrast(70%) brightness(80%);
}

body.dark_mode .relation-list::-webkit-scrollbar-thumb {
  background: #4f4f4f;
}

body.dark_mode .relation-list__item.is-selected,
body.dark_mode .relation-list__item:hover {
  background: #3e3e3e;
}
</style>
<style>
.highlight {
  background: var(--mark-bg);
  color: var(--memoContentColor);
  font-weight: bold;
  display: inline-block;
}
</style>
